/**
 * Re-export OptionChip from a3s-ui as TimeOptionButton for backward compat.
 */
export {
  OptionChip as TimeOptionButton,
  type OptionChipProps as TimeOptionButtonProps,
} from "@visioni/a3s-ui/components";
